import type React from 'react'
import type { IconProps } from './types'

const ParagraphMarkdownIcon: React.FC<IconProps> = ({ size = 20, className = 'fill-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path
			d='M15.604 9.59961C15.6039 8.91028 15.3297 8.2492 14.8423 7.76172C14.3547 7.27412 13.693 7 13.0034 7H9.20361V12.2002H13.0034C13.693 12.2002 14.3547 11.9261 14.8423 11.4385C15.3298 10.9509 15.604 10.2891 15.604 9.59961ZM17.604 9.59961C17.604 10.8196 17.119 11.9899 16.2563 12.8525C15.3937 13.7152 14.2234 14.2002 13.0034 14.2002H9.20361V18C9.20361 18.5523 8.7559 19 8.20361 19C7.65133 19 7.20361 18.5523 7.20361 18V6C7.20361 5.44772 7.65133 5 8.20361 5H13.0034C14.2234 5 15.3937 5.48499 16.2563 6.34766C17.1188 7.21021 17.6039 8.37985 17.604 9.59961Z'
			fill='#1E293B'
		/>
	</svg>
)

export default ParagraphMarkdownIcon
